import styled from 'styled-components'
import BFit1 from '../../assets/img/1-01.png'
import BFit4 from '../../assets/img/2-01.png'
import BFit2 from '../../assets/img/3-01.png'
import BFit3 from '../../assets/img/4-01.png'

const Benefitdata = [
  {
    id: 1,
    title: '80% Reward for LPs',
    text: 'Provide liquidity to earn from trading and limit order fees',
    img: `${BFit1}`,
  },
  {
    id: 2,
    title: 'Flexible Trading & Low Slippage',
    text: 'Trading from 0.015% fee along with lower slippage and optimized routes',
    img: `${BFit2}`,
  },
  {
    id: 3,
    title: 'Limit Order with 0% Fee',
    text: 'Make a limit order no trading fee and slippage',
    img: `${BFit3}`,
  },
  {
    id: 4,
    title: 'One-transaction V3 Farms',
    text: 'Automatically participate in an active V3 Farms by getting into price range as LP.',
    img: `${BFit4}`,
  },
]

const BenefitsSection = () => {
  return (
    <Container>
      {Benefitdata.map((data) => (
        <Card key={data.id}>
          <ImgWrapper>
            <img src={data.img} alt={data.title} />
          </ImgWrapper>
          <TextWrapper>
            <Title>{data.title}</Title>
            <Description>{data.text}</Description>
          </TextWrapper>
        </Card>
      ))}
    </Container>
  )
}

export default BenefitsSection

/* ---------- Styled Components ---------- */
const Container = styled.div`
  display: grid;
  gap: 1.5rem;
  padding: 0 1.2rem;
  margin: 2rem auto 4rem auto;
  max-width: 1200px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (min-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }
`
const Card = styled.div`
  background: #fff;
  border-radius: 0.9rem;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  &:hover {
    background: #f2f6fc;
    transform: translateY(-4px);
  }
`
const ImgWrapper = styled.div`
  margin-bottom: 1.2rem;

  img {
    width: 140px;
    height: auto;
    margin: 0 auto;
    display: block;

    @media (min-width: 768px) {
      width: 160px;
    }

    @media (min-width: 1100px) {
      width: 180px;
    }
  }
`

const TextWrapper = styled.div`
  text-align: center;
`

const Title = styled.h2`
  font-weight: 700;
  font-size: 1rem;
  color: #000;
  margin-bottom: 0.6rem;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 1.05rem;
  }
`
const Description = styled.p`
  font-weight: 500;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #708db7;
  max-width: 220px;
`
